import { Component, OnInit } from '@angular/core';
import { Repos } from '../models/repos';
import { GithubService } from '../services/github.service';

@Component({
  selector: 'app-github-repos',
  templateUrl: './github-repos.component.html',
  styleUrls: ['./github-repos.component.css']
})
export class GithubReposComponent implements OnInit {

  username: string;

  repos: Repos[];
  
  loading: boolean = false;
  errorMessage: string;

  constructor(private githubService: GithubService) { }

  ngOnInit(): void {
  }

  public getRepos() {
    this.loading = true;
    this.errorMessage = "";

    return this.githubService.getRepos(this.username)
      .subscribe(
        (response) => {                            
          this.repos = response;
          this.loading = false;
        },
        (error) => {                                
          this.errorMessage = error;
          this.loading = false;
        }
      );
  }


}
